<section class="wrapper">
  <header>
    <div class="header-actions">
      <button [routerLink]="['/collections/new']" class="bciti-button bciti-button--blue">
        {{ 'pages.collections.list.button.add-collection' | translate }}
      </button>
    </div>
  </header>
  <section class="content">
    <app-collections-table></app-collections-table>
  </section>
</section>